import React from "react";
import { Row, Col } from "antd";
import JobInfoCard from "./JobInfoCard";
import FunnelChartSection from "../FunnelChartSection";
import { JobDescriptionEntity } from "../../../../../../../Entities/JobDescription";
import "./index.scss";

interface BasicDetailsSectionProps {
  jobPost: JobDescriptionEntity;
  jobLink: string;
  themeColor?: string;
}

const BasicDetailsSection: React.FC<BasicDetailsSectionProps> = ({
  jobPost,  
  themeColor,
}) => {
  return (
    <div
      className="insight-section basic-details-section"
    >
      <JobInfoCard
        jobPost={jobPost}
        themeColor={themeColor}
      />

      {/* Application Funnel */}
      {/* <FunnelChartSection
        jobPostId={jobPost._id}
        themeColor={themeColor}
      /> */}
    </div>
  );
};

export default BasicDetailsSection;
